import { convertDate } from '@/entities/query/query-utils';
import type { PublicFilter } from '@/features/(insight)/shared/public-filter/use-public-filter';
import type { PublicFilterWithDates } from '../post/api';
import type { PostFilterMap } from '../post/models';

export const buildPublicFilterWithDates = (
  publicFilter: PublicFilter,
  startDate?: string,
  endDate?: string,
) => {
  return {
    keyword: publicFilter.keyword,
    sponsored: publicFilter.contentType,
    platform: publicFilter.platform,
    start_date: convertDate(startDate),
    end_date: convertDate(endDate),
    gender: publicFilter.gender,
    race: publicFilter.race,
    age: publicFilter.age,
    location: publicFilter.location,
  };
};

export const buildInsightReqBody = (
  startDate: string,
  endDate: string,
  limit: number,
  publicFilter: PublicFilter,
  privateFilter?: PostFilterMap,
) => {
  const publicFilterBody: PublicFilterWithDates = buildPublicFilterWithDates(
    publicFilter,
    startDate,
    endDate,
  );
  return {
    limit,
    filter: {
      public: publicFilterBody,
      private: privateFilter,
    },
  };
};
